import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UtenteWebService } from '../services/utente/utente-web.service';
import { UtenteService } from '../services/utente/utente.service';
import { UtilityService } from '../services/utility/utility.service';

export const authGuard: CanActivateFn = (route, state) => {
  const utenteService = inject(UtenteService);
  const utenteWebService = inject(UtenteWebService);
  const router = inject(Router);
  const utilityService = inject(UtilityService);

  return utenteWebService.checkAuth().pipe(
    switchMap((autorizzato) => {
      if (!autorizzato) {
        utilityService.closeDialog();
        utenteService.updateLoginState(false);
        return of(router.parseUrl('/login'));
      } else {
        utenteService.updateLoginState(true);
        return utenteService.aggiornaInfoUtente();
      }
    }),
  );
};
